// removed by extract-text-webpack-plugin
module.exports = {"SideDrawer":"SideDrawer__SideDrawer__21TuB","Open":"SideDrawer__Open__1pVYR","Close":"SideDrawer__Close__3Yv1l","Logo":"SideDrawer__Logo__3TkPv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/SideDrawer/SideDrawer.css
// module id = 300
// module chunks = 3